import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps, FormattedHTMLMessage } from 'react-intl';
import { Link } from 'react-router-dom'

import Logo from '@uniiverse/library/assets/universe.svg'
import Balloon from '../assets/Images/Balloon.png';

const style = require('./NotFound.css');
import { locale } from './Locale';

const NotFoundComponent: FunctionComponent<InjectedIntlProps> = ({
  intl: { formatMessage },
}) => {
  return (
    <div id="navbar" className={style.notFound}>
      <div className={style.logo}>
          <Link to="/" href="/"><Logo /></Link>
      </div>
      <div className={style.notFound__topper} />
      <div className={style.notFound__message}>
        <h1>
          4
          <img src={Balloon} />
          4
        </h1>
        <FormattedHTMLMessage
          tagName='p'
          {...locale.pageNotFound}
        />
      </div>
      <div className={style.notFound__credit}>
        <a href="http://www.andrewbmyers.com/" target="_blank" rel="nofollow">
          {formatMessage(locale.pageNotFoundCredit, { name: 'Andrew B. Myers'})}
        </a>
      </div>
      <div className={style.notFound__background} />
    </div>
  )
  };

export const NotFound = injectIntl(NotFoundComponent);
